export default function Container({ className, children, ...props }) {
	return (
		<main className={className} {...props}>
			{children}
		</main>
	);
}
